export default {
  CONTRACT: "contract",
  CONTRACT_PAYMENTS_REPORT: "contract_payments_report",
};
